module.exports = __webpack_public_path__ + "img/PL09029.95a4299a.png";